import { render, staticRenderFns } from "./BillingOrderBatchReportCrudLayout.vue?vue&type=template&id=1dd11f11&scoped=true"
import script from "./BillingOrderBatchReportCrudLayout.vue?vue&type=script&lang=js"
export * from "./BillingOrderBatchReportCrudLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd11f11",
  null
  
)

export default component.exports